import { render, staticRenderFns } from "./PosModal.vue?vue&type=template&id=63c9b2a8&"
import script from "./PosModal.vue?vue&type=script&lang=js&"
export * from "./PosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports